export function sanitizeCreditNameInput(value: string): string {
  return (
    value
      // Replace " and " with " & " (case insensitive, requires spaces on both sides)
      .replace(/ and /gi, ' & ')
      // Only allow letters (including accented), numbers, spaces, apostrophes, periods, and ampersands
      .replace(/[^a-zA-Z0-9\s'.&\u00C0-\u024F]/g, '')
  )
}
